import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import TransactionSummary from "./TransactionSummary.js";

function mapStateToProps(state) {
  return {
    isSimulateMode: state.isSimulateMode,
    searchObj: state.searchObj,
    texts: state.translatedTexts,
    userDetails: state.userDetails,
    simulatedUserDetails: state.simulatedUserDetails,
    selectedTransactions: state.searchPageComponents.selectedTransactions,
    searchTransactionResponse: state.searchTransactionResponse,
    businessActivities: state.businessActivities,
    simulatedBusinessActivities: state.simulatedBusinessActivities,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionSummary);
